export default "__VITE_ASSET__DOVLMKML__"